// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-bar {
  height: 60px;
  padding: 0 15px 0 10px;
}
.view-default {
  /* SCSS zDox Theme 400 */
  background: #2ab4c0;
}
.view-share-file {
  background: #fff
}
.top-bar .back-button {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, .7);
  cursor: pointer;
  outline: none;
  width: 32px;
  height: 32px;
}

.img-logo {
  margin-left: 10px;
  height: 24px;
}

.img-logo.custom {
  height: 32px;
}

.info-panel-toggle {
  cursor: pointer;
  display: inline-block;
  fill: #fff;
  margin-left: 1em;
  min-width: 12px;
  min-height: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/dms/viewer-controller/viewer-top-bar/viewer-top-bar.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE;AACF;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".top-bar {\n  height: 60px;\n  padding: 0 15px 0 10px;\n}\n.view-default {\n  /* SCSS zDox Theme 400 */\n  background: #2ab4c0;\n}\n.view-share-file {\n  background: #fff\n}\n.top-bar .back-button {\n  background: transparent;\n  border: none;\n  color: rgba(255, 255, 255, .7);\n  cursor: pointer;\n  outline: none;\n  width: 32px;\n  height: 32px;\n}\n\n.img-logo {\n  margin-left: 10px;\n  height: 24px;\n}\n\n.img-logo.custom {\n  height: 32px;\n}\n\n.info-panel-toggle {\n  cursor: pointer;\n  display: inline-block;\n  fill: #fff;\n  margin-left: 1em;\n  min-width: 12px;\n  min-height: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
